
import React from "react";

type AiFieldHeaderProps = {
  label?: string; // Made optional if used just for the button
  loading: boolean;
  onClick: () => void;
  disabled?: boolean;
};

export function AiFieldHeader({ label, loading, onClick, disabled }: AiFieldHeaderProps) {
  return (
    <div style={{ marginBottom: 8, display: 'flex', alignItems: 'center', justifyContent: 'space-between', flexWrap: 'wrap', gap: 8 }}>
      {label && <span className="label" style={{ marginBottom: 0 }}>{label}</span>}
      <button
        type="button"
        className="btn-ai-helper"
        style={{
          fontSize: 13,
          padding: '4px 16px', // Matches py-1 px-4 visually
          color: '#fff',
          background: disabled ? '#555' : 'linear-gradient(to right, #A447FF, #FF5CC4)', // Updated Gradient
          border: 'none',
          borderRadius: '999px', // Capsule shape
          cursor: disabled ? 'not-allowed' : 'pointer',
          display: 'inline-flex',
          alignItems: 'center',
          gap: 6,
          opacity: disabled ? 0.7 : 1,
          boxShadow: '0 2px 5px rgba(0,0,0,0.2)',
          transition: 'transform 0.1s ease',
          fontWeight: 500,
          width: 'auto',
          lineHeight: '20px'
        }}
        onClick={onClick}
        disabled={loading || disabled}
        onMouseDown={e => !disabled && (e.currentTarget.style.transform = 'scale(0.97)')}
        onMouseUp={e => !disabled && (e.currentTarget.style.transform = 'scale(1)')}
        onMouseLeave={e => !disabled && (e.currentTarget.style.transform = 'scale(1)')}
      >
        {loading ? (
          <>
            <span className="animate-spin">↻</span> AI 解析中...
          </>
        ) : (
          <>
            <span>✨</span> AI 產生草稿
          </>
        )}
      </button>
    </div>
  );
}
